export const ptBR = {
    values: {
        'Choose a dashboard to link': 'Escolha um dashboard para linkar',
        'Search by dashboard name': 'Procure pelo nome do dashboard',
        'Filter by perspective': 'Filtro por perspectiva',
        'Clear search': 'Limpar pesquisa',
        'DASHBOARD NAME': 'NOME DA DASHBOARD',
        'LAST CHANGE': 'ÚLTIMAS MUDANÇAS',
        'Error loading dashboards': 'Error ao carregar dashboards',
        Loading: 'Carregando',
        'All visible dashboards are already linked': 'Todos os dashboards visiveis estão linkados',
        Retry: 'Tentando novamente',
        'No dashboards found': 'Nunhum dashboard foi encontrado'
    }
}
